import { LatLngExpression } from 'leaflet'
import { Marker, Tooltip } from 'react-leaflet'
import DayJS from 'react-dayjs'

import L from 'leaflet'
import { MapResource, MapTask } from './map-types'
import { truckIconText } from './map-constants'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(LocalizedFormat)

export const getTaskMarker = (num: number, task: LatLngExpression | MapTask, styles: string): JSX.Element => {
  const circleStyles = styles || 'border: 2px solid #1890FF; color: #1890FF;'
  const number = `<div style="${circleStyles}" class='circle-id'><span>${num}</span></div>`
  const icon = L.divIcon({
    className: 'custom-task-icon',
    html: `<div class='marker-pin'>${number}</div>`,
    iconSize: [30, 42],
    iconAnchor: [15, 42]
  })
  const random = Math.random() * 10000

  if (Array.isArray(task)) {
    return <Marker key={`task-marker-${random}-${num}`} position={task} icon={icon} />
  } else {
    const {
      destination: { latitude, longitude }
    } = task as MapTask
    return <Marker key={`task-marker-${random}-${num}`} position={[latitude, longitude]} icon={icon} />
  }
}

export const getResourcesMarker = (num: number, resource: MapResource, color: string, styles = ''): JSX.Element => {
  const { latitude, longitude, first_name: firstName, last_name: lastName } = resource
  const name = `${firstName} ${lastName.charAt(0).toUpperCase()}`
  const icon = L.divIcon({
    className: 'custom-resource-marker',
    html: `<div style="${styles}" class='${color}'><image src="${truckIconText}" /><span>${name}</span></div>`,
    iconSize: [20, 32],
    iconAnchor: [10, 32]
  })
  const random = Math.random() * 10000
  if (latitude && longitude) {
    return <Marker key={`resource-marker-${random}-${num}`} position={[latitude, longitude]} icon={icon} />
  }
  return <div key={num} />
}

export const JobResourceMarker = ({
  resource,
  styles = ''
}: {
  resource: MapResource
  styles?: string
}): JSX.Element => {
  const { latitude, longitude, first_name: firstName, last_name: lastName, stops, stop, lastUpdate } = resource
  const resourceIcon = `<div class='map-marker-icon map-job-resource-icon'><image src="${truckIconText}" /></div>`
  const icon = L.divIcon({
    className: 'job-resource-marker',
    html: `<div class='marker-pin marker-job-resource' style='${styles}'>${resourceIcon}</div>`,
    iconSize: [20, 32],
    iconAnchor: [12, 36]
  })
  if (latitude && longitude) {
    return (
      <Marker position={[latitude, longitude]} icon={icon}>
        <Tooltip direction='bottom' className='gungnir-job-tooltip'>
          <div>{`${firstName} ${lastName}`}</div>
          <div className='gungnir-jm-gray'>Última ubicación</div>
          <div className='gungnir-jm-gray'>{lastUpdate && <DayJS format='LT'>{lastUpdate.toString()}</DayJS>}</div>
          <div className='gungnir-jm-gray'>
            {stop || 0} of {stops || 0}
          </div>
        </Tooltip>
      </Marker>
    )
  }
  return <></>
}
